import {Employee, EmployeeFull, ProfilePage, Team, UserService} from 'client';
import {Atom, atom} from 'jotai';
import {atomWithImmer} from 'jotai-immer';
import {getService} from 'utilities';

type LoggedInEmployeeAtomType = Omit<
  ProfilePage,
  'employeeTeams' | 'eventSubscriptions' | 'showPto'
> & {
  employeeTeams: Array<Team> | null;
};

// Logged in employee atom includes extra fields that are not always needed.
// @see employeeAtom for a faster alternative.
export const loggedInEmployeeAtom = atomWithImmer<LoggedInEmployeeAtomType>({
  employee: {} as EmployeeFull,
  reportingLine: [],
  directReports: [],
  teamMembers: [],
  delegates: [],
  delegatedBy: [],
  employeeTeams: null,
  workingWithMe: '',
  admin: {} as Employee,
  supportedLeaders: [],
});
export type LoggedInEmployeeAtomValue =
  typeof loggedInEmployeeAtom extends Atom<infer T> ? T : never;

// Derived atom from userProfileAtom to more easily manage modifying delegates
export const delegatesAtom = atom(
  (get) => get(loggedInEmployeeAtom).delegates,
  async (_, set, updatedDelegates: Employee[]) => {
    const ldapArray = updatedDelegates.map(({ldap}) => ldap);
    await getService(UserService).setDelegatesApiV1DelegatesPost(ldapArray);

    set(loggedInEmployeeAtom, (draft) => {
      draft.delegates = updatedDelegates;
    });
  }
);

// This resolves much faster than loggedInEmployeeAtom.
// loggedInEmployeeAtom includes extra fields that are not always needed.
export const employeeAtom = atom<Employee | undefined>();
